export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_relation_business_type') || '关联业务单类型',
    field: 'linkBillTypeName',
    minWidth: 120,
    align: 'center',
    fixed: 'left',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('table_label_relation_business_No') || '关联业务单号',
    field: 'linkBillNo',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('table_label_relation_business_explain') || '关联业务说明',
    field: 'linkBillDescription',
    minWidth: 350,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('table_label_linkTime') || '关联时间',
    field: 'linkTime',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: 'title',
  },
]
